import isFunction from "lodash-es/isFunction";
import { mockRegistry } from "@/api/mock-data";

/**
 * Resolves mock data for a given method and params.
 * Uses mockRegistry: if the entry is a function, calls it with params; otherwise returns it as-is.
 * Used by useQuery, usePaginateQuery, and useMutation for consistent mock resolution.
 */
export function getMockData<Args, Response>(
  method: { name: string },
  params: Args,
): Response {
  const mockData = mockRegistry[method.name];
  if (!mockData) {
    // eslint-disable-next-line no-console
    console.error(`Mock data not found for method: ${method.name}`);
  }
  const data = isFunction(mockData)
    ? (mockData(params as Args) as Response)
    : (mockData as Response);

  return data;
}
